import { Pipe, PipeTransform } from '@angular/core';
import { NiveauQualification } from '../../models/niveauQualification';

@Pipe({
	name: 'filterNiveauQualificationByName'
})
export class FilterNiveauQualificationByNamePipe implements PipeTransform {
	transform(niveauQualification: NiveauQualification[], filter: string): NiveauQualification[] {
		if (
			!niveauQualification ||
			!filter ||
			niveauQualification === null ||
			filter === null ||
			filter === ''
		) {
			return niveauQualification;
		}

		return niveauQualification.filter((niveauQualification: NiveauQualification) => {
			if (niveauQualification.name) {
				// TODO: add lastName too
				return niveauQualification.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
